import React from 'react'
import { Image } from 'semantic-ui-react'
import logo from 'assets/images/RDP.png'
import './ForbiddenPage.scss'

export default function ForbiddenPage() {
    return (
        <div id="forbidden" className='d-flex flex-grow-1 flex-column'>
            <h2 className='mt-0'>403 - Não autorizado</h2>
            <Image className='logo' size='small' rounded src={logo} />
        </div>
    )
}
